import React, { useState } from "react";
import { useGlobalContext } from "../../GlobalContext";
import generatePDF from "./pdf/mutasirealisasi";

function MutasiRealisasiComp() {
  const { bulan, api } = useGlobalContext();
  const Tahunaktif = new Date().getFullYear();
  const tahunterakhir = Array.from({ length: 3 }, (_, i) => Tahunaktif - i);

  const [selectedBulan, setSelectedBulan] = useState(0);
  const [selectedYear, setSelectedYear] = useState(tahunterakhir[0]);
  const [jenisPin, setJenisPin] = useState("A");
  const [loading, setLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const handleSubmit = async () => {
    const bulanNumber = (selectedBulan + 1).toString().padStart(2, "0");
    const periode = `${selectedYear}${bulanNumber}`;
    const namaBulan = bulan[selectedBulan] || "Tidak Diketahui";
    const tahun = selectedYear;

    setLoading(true);

    try {
      const response = await api.get(`/api/piutang/getrealisasi/${periode}/${jenisPin}`);
      
      let data = [];
      if (Array.isArray(response.data)) {
        data = response.data;
      } else if (response.data && Array.isArray(response.data.data)) {
        data = response.data.data;
      } else if (response.data && typeof response.data === 'object') {
        const keys = Object.keys(response.data);
        for (const key of keys) {
          if (Array.isArray(response.data[key])) {
            data = response.data[key];
            break;
          }
        }
      }

      if (data.length === 0) {
        alert("Data Realisasi tidak ditemukan.");
      } else {
        generatePDF(periode, data, namaBulan, tahun, jenisPin);
      }
    } catch (error) {
      console.error("Gagal fetch:", error);
      if (error.response) {
        alert(`Server error: ${error.response.status} - ${error.response.data?.message || error.response.statusText}`);
      } else if (error.request) {
        alert("Tidak dapat terhubung ke server. Pastikan backend berjalan.");
      } else {
        alert(`Terjadi kesalahan: ${error.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleExportExcel = async () => {
    const bulanNumber = (selectedBulan + 1).toString().padStart(2, "0");
    const periode = `${selectedYear}${bulanNumber}`;
    const namaBulan = bulan[selectedBulan] || "Tidak Diketahui";
    const tahun = selectedYear;

    setIsExporting(true);
    try {
      const response = await api.get(
        `/api/exsportexcell/realisasi/${periode}/${jenisPin}`,
        {
          responseType: "blob",
        }
      );

      const filename = `Mutasi_Realisasi_${jenisPin}_${namaBulan}_${tahun}.xlsx`;
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Export Excel error:", err);
      alert("Gagal mengekspor Excel.");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="row">
        <div className="col-md-12">
          <div className="card card-info" style={{ width: "400px" }}>
            <div className="card-header">
              <h5 className="card-title">Laporan Mutasi Realisasi Piutang</h5>
            </div>
            <div className="card-body">
              <form className="form-horizontal">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Periode</label>
                  <div className="col-sm-5">
                    <select
                      className="form-control"
                      value={selectedBulan}
                      onChange={(e) =>
                        setSelectedBulan(parseInt(e.target.value, 10))
                      }
                    >
                      {bulan.map((item, index) => (
                        <option key={index} value={index}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-sm-4">
                    <select
                      className="form-control"
                      value={selectedYear}
                      onChange={(e) => setSelectedYear(e.target.value)}
                    >
                      {tahunterakhir.map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">
                    Jenis
                  </label>
                  <div className="col-sm-6">
                    <select
                      className="form-control"
                      value={jenisPin}
                      onChange={(e) => setJenisPin(e.target.value)}
                    >
                      <option value="A">Piutang D</option>
                      <option value="B">Piutang C</option>
                    </select>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-sm btn-primary mr-2"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "Memproses..." : "Cetak"}
              </button>
              <button
                className="btn btn-sm btn-success"
                onClick={handleExportExcel}
                disabled={isExporting}
              >
                {isExporting ? "Mengekspor..." : "Export Excel"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MutasiRealisasiComp;
